import _ from 'underscore';
const initialState = {
  filter: '',
  videos: [],
  playlist: {},
}

const videoSearch = (state = initialState, action) => {
  switch(action.type) {
    case 'CHANGE_FILTER':
      return {
        ...state,
        filter: action.filter,
      }
    case 'CHANGE_VIDEOS':
      return {
        ...state,
        videos: action.results
      }
    case 'ADD_VIDEO':
      return {
        ...state,
        addedVideos: {
          ...state.addedVideos,
          [action.id]: true
        }
      }
    case 'UPDATE_PLAYLIST':
      if(!action.playlist) {
        return state;
      }
      return {
        ...state,
        playlist: _.indexBy(_.values(action.playlist), 'id')
      }
    default:
      return state
  }
}

export default videoSearch



// WEBPACK FOOTER //
// ./src/reducers/VideoSearch.js